import * as React from "react";
import type { SVGProps } from "react";
const SvgCamera01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M7.2 6.12v1a1 1 0 0 0 .864-.496zm1.68-2.88v-1a1 1 0 0 0-.864.496zm6.24 0 .864-.504a1 1 0 0 0-.864-.496zm1.68 2.88-.864.504a1 1 0 0 0 .864.496zM2.4 18.36h1V8.52h-2v9.84zM4.8 6.12v1h2.4v-2H4.8zm2.4 0 .864.504 1.68-2.88-.864-.504-.864-.504-1.68 2.88zm1.68-2.88v1h6.24v-2H8.88zm6.24 0-.864.504 1.68 2.88.864-.504.864-.504-1.68-2.88zm1.68 2.88v1h2.4v-2h-2.4zm4.8 2.4h-1v9.84h2V8.52zm0 9.84h-1a1.4 1.4 0 0 1-1.4 1.4v2a3.4 3.4 0 0 0 3.4-3.4zM19.2 6.12v1a1.4 1.4 0 0 1 1.4 1.4h2a3.4 3.4 0 0 0-3.4-3.4zM2.4 8.52h1a1.4 1.4 0 0 1 1.4-1.4v-2a3.4 3.4 0 0 0-3.4 3.4zm2.4 12.24v-1a1.4 1.4 0 0 1-1.4-1.4h-2a3.4 3.4 0 0 0 3.4 3.4zm10.8-7.92h-1a2.6 2.6 0 0 1-2.6 2.6v2a4.6 4.6 0 0 0 4.6-4.6zm-3.6 3.6v-1a2.6 2.6 0 0 1-2.6-2.6h-2a4.6 4.6 0 0 0 4.6 4.6zm-3.6-3.6h1a2.6 2.6 0 0 1 2.6-2.6v-2a4.6 4.6 0 0 0-4.6 4.6zm3.6-3.6v1a2.6 2.6 0 0 1 2.6 2.6h2a4.6 4.6 0 0 0-4.6-4.6zm7.2 11.52v-1H4.8v2h14.4z"
    />
  </svg>
);
export default SvgCamera01;
